import { useMemo } from "preact/hooks";
import style from "./style.css";
import { isValidArray } from "../../utils/checks";
import GamesWrapper from "../games-wrapper/index";

const groupByCompetitionId = (games) => {
  const map = {};

  if (!isValidArray(games)) return undefined;

  for (const game of games) {
    const compId = game.competition.id;
    if (!map[compId]) {
      map[compId] = {
        competition: game.competition,
        games: [],
        startTimeStamp: Number.MAX_VALUE,
      };
    }
    map[compId].games.push(game);
    if (game.timestamp < map[compId].startTimeStamp) {
      map[compId].startTimeStamp = game.timestamp;
    }
  }

  const sortedComps = Object.values(map).sort((a, b) => {
    const byPriority = (b?.competition?.priority ?? 0) - (a?.competition?.priority ?? 0);
    return byPriority ? byPriority : a.startTimeStamp - b.startTimeStamp;
  });

  return sortedComps;
};

const CompetitionGameList = ({ games, isLoading, gamesNum }) => {
  const sortedComps = useMemo(() => groupByCompetitionId(games), [games]);

  if (isLoading) {
    return (
      <div class={style.home}>
        {Array(5)
          .fill()
          .map((info, i) => (
            <div key={i}>
              <GamesWrapper isLoading={true} logo={true} title={" "} gamesNum={gamesNum} />
            </div>
          ))}
      </div>
    );
  }
  if (!sortedComps || sortedComps.length == 0) {
    return (
      <div class={style.no_games}>
        <span>No Games</span>
      </div>
    );
  }
  return (
    <div>
      {sortedComps &&
        sortedComps?.map((info) => (
          <div key={info.competition.id}>
            <GamesWrapper
              title={`${info.competition.name} - ${info.competition.country}`}
              logo={info.competition?.logo}
              headerLink={info.competition?.id ? `/competition/${info.competition.id}` : undefined}
              competition={info.competition}
              games={info.games}
            />
          </div>
        ))}
    </div>
  );
};

export default CompetitionGameList;
